import { apiCall } from '@/util/apiCall'
import type { Line } from '@common/types/Line'
import { getFullLine, setLine } from '../lines'
import { makeLoader } from './load'

export const loadFullLine = makeLoader<{ line: string }>({
	id: ({ line }) => `fullline:${line}`,
	loader: async (api, { line }) => {
		const { data: lineData } = await apiCall<{ data: Line }>(
			'/lines/:line',
			{
				signal: api.signal,
				params: { line, geojson: 'true' },
				cache: 'preload-if-ssr',
			},
		)
		return setLine(lineData)
	},
	check: (state, { line }) => !!getFullLine(state, line)?.routes[0].geojson,
})
